import React from 'react';
import { H1 } from 'mf-react-ui/Typography';
import Button from 'mf-react-ui/Button';
import auth from '../../../../features/auth/utils/mym';
import './Message.scss';

const Message: React.FC = () => (
  <div className="orders-no-auth section">
    <div className="orders-no-auth__inner">
      <div className="orders-no-auth__img" />
      <H1 view="p" className="orders-no-auth__message">
        Чтобы посмотреть заказы, авторизуйтесь
      </H1>
      <div className="orders-no-auth__actions">
        <Button className="orders-no-auth__button" onClick={() => auth.authOTP()}>
          Войти
        </Button>
      </div>
    </div>
  </div>
);

export default Message;
